import React from 'react';
import { StyleProp, ViewStyle, View } from 'react-native';
import Svg, { Path, Defs, Stop, LinearGradient } from 'react-native-svg';

const HexagonBee = React.memo(
  (props: {
    width?: number;
    height?: number;
    color?: string;
    containerStyle?: StyleProp<ViewStyle>;
  }) => {
    return (
      <View style={props.containerStyle}>
        <Svg
          width={props.width ?? 59}
          height={props.height ?? 52}
          viewBox="0 0 59 52"
          fill="none"
          {...props}
        >
          <Path
            d="M46.4319 2.88252C45.5362 1.30861 43.3104 0.0332031 41.4917 0.0332031H18.2021C16.3835 0.0332031 14.1848 1.30861 13.2619 2.88252L1.61713 23.0448C0.721374 24.6187 0.721374 27.1696 1.61713 28.7435L13.2619 48.9058C14.1577 50.4797 16.3835 51.7551 18.2021 51.7551H41.4917C43.3104 51.7551 45.509 50.4797 46.4319 48.9058L58.0767 28.7435C58.9725 27.1696 58.9725 24.6187 58.0767 23.0448L46.4319 2.88252Z"
            fill="url(#paint0_linear_2926_12805)"
          />
          <Path
            d="M45.2623 4.37294C44.4233 2.89387 42.3384 1.69531 40.635 1.69531H18.8202C17.1168 1.69531 15.0573 2.89387 14.1929 4.37294L3.28552 23.3204C2.44649 24.7994 2.44649 27.1966 3.28552 28.6756L14.1929 47.6231C15.0319 49.1021 17.1168 50.3007 18.8202 50.3007H40.635C42.3384 50.3007 44.3979 49.1021 45.2623 47.6231L56.1697 28.6756C57.0087 27.1966 57.0087 24.7994 56.1697 23.3204L45.2623 4.37294Z"
            fill={props.color ?? 'white'}
          />
          <Path
            d="M36.2939 31.7151C36.4297 31.4096 36.7014 31.3756 36.8938 31.6585L39.0784 34.8043C39.2708 35.0872 39.1576 35.3475 38.818 35.3927L34.9809 35.8906C34.6413 35.9359 34.4829 35.7209 34.6187 35.404L36.2939 31.7151Z"
            fill="#35302D"
          />
          <Path
            d="M28.2905 20.3628C25.6516 17.7246 25.6516 13.4473 28.2905 10.8091C30.9294 8.17094 35.2079 8.17094 37.8468 10.8091C40.4857 13.4473 40.4857 17.7246 37.8468 20.3628C35.2079 23.0009 30.9294 23.0009 28.2905 20.3628Z"
            fill="#BFE5F4"
          />
          <Path
            d="M38.9001 12.2051C39.9527 14.0269 40.1565 16.3014 39.2283 18.3722C38.1077 20.8503 35.6855 22.3101 33.1387 22.3327C32.0861 20.5109 31.8823 18.2364 32.8105 16.1769C33.9197 13.6874 36.342 12.2277 38.9001 12.2051Z"
            fill="#A9DCF0"
          />
          <Path
            d="M34.7046 25.562C32.0656 22.9238 32.0657 18.6465 34.7046 16.0083C37.3435 13.3702 41.622 13.3702 44.2609 16.0083C46.8998 18.6465 46.8998 22.9238 44.2609 25.562C41.622 28.2002 37.3435 28.2002 34.7046 25.562Z"
            fill="#DCF1F9"
          />
          <Path
            d="M22.5681 13.9702L24.4062 18.8281L22.9665 19.3726L21.1284 14.5147L22.5681 13.9702Z"
            fill="#35302D"
          />
          <Path
            d="M15.6123 23.8052C13.4277 28.637 14.8313 34.1704 18.7137 37.4067C19.4947 38.063 20.3889 38.6401 21.3736 39.0815C21.6793 39.2172 21.9962 39.3643 22.3018 39.4322C23.6035 39.9188 24.9391 40.1112 26.2634 40.0999C28.0292 40.0886 29.7836 39.6586 31.3343 38.8325C33.6321 37.7009 35.5337 35.8225 36.6769 33.2878C37.8201 30.753 37.9786 28.0938 37.2995 25.6157C36.8693 23.9409 36.0317 22.3454 34.8772 21.0102C34.0056 20.0144 32.9756 19.1431 31.7531 18.4867C31.4928 18.3057 31.1872 18.1699 30.8816 18.0228C29.8968 17.5815 28.8781 17.2873 27.8481 17.1628C22.8564 16.382 17.7968 18.9733 15.6123 23.8052Z"
            fill="#FFE200"
          />
          <Path
            d="M19.153 19.3574C16.3798 25.6037 19.1643 32.9251 25.4123 35.7427C28.5251 37.1458 31.9094 37.1572 34.875 36.0595C33.8676 37.225 32.6791 38.1869 31.3208 38.8432C29.7701 39.6693 28.0157 40.0879 26.2499 40.1106C24.9256 40.1219 23.59 39.9295 22.2883 39.4429C21.9827 39.375 21.6771 39.2279 21.3602 39.0922C20.3754 38.6508 19.4812 38.0737 18.7002 37.4174C14.8178 34.1811 13.4256 28.6477 15.5988 23.8158C16.4364 21.9827 17.6702 20.4777 19.153 19.3574Z"
            fill="#FFB600"
          />
          <Path
            d="M20.1968 21.9136C20.6495 20.9065 21.8267 20.4652 22.8341 20.9179C23.8415 21.3705 24.2829 22.5473 23.8301 23.5544C23.3774 24.5615 22.2002 25.0029 21.1928 24.5502C20.1854 24.0976 19.744 22.9208 20.1968 21.9136Z"
            fill="#35302D"
          />
          <Path
            d="M22.2675 22.3481C22.1312 21.9854 22.3149 21.5809 22.6778 21.4447C23.0406 21.3085 23.4452 21.4922 23.5815 21.8549C23.7177 22.2177 23.534 22.6221 23.1711 22.7583C22.8083 22.8945 22.4037 22.7109 22.2675 22.3481Z"
            fill="white"
          />
          <Path
            d="M34.8746 21.0195L26.2609 40.0979C28.0267 40.0866 29.7811 39.6566 31.3318 38.8306L37.2969 25.6251C36.8668 23.9503 36.0292 22.3548 34.8746 21.0195Z"
            fill="#35302D"
          />
          <Path
            d="M27.845 17.1836L18.7105 37.4162C19.4915 38.0725 20.3857 38.6496 21.3705 39.0909C21.6761 39.2267 21.993 39.3738 22.2987 39.4417L31.75 18.5075C31.4897 18.3265 31.184 18.1907 30.8784 18.0436C29.8937 17.591 28.875 17.3081 27.845 17.1836Z"
            fill="#35302D"
          />
          <Path
            d="M19.7409 13.9936C19.3647 12.98 19.8816 11.8534 20.8955 11.4773C21.9093 11.1012 23.0363 11.6179 23.4125 12.6315C23.7887 13.6451 23.2718 14.7717 22.258 15.1479C21.2441 15.524 20.1172 15.0072 19.7409 13.9936Z"
            fill="#FFE200"
          />
          <Path
            d="M20.8664 26.1924C21.1041 25.6605 21.7266 25.4229 22.2586 25.6605C22.7906 25.8982 23.0283 26.5205 22.7906 27.0524C22.5529 27.5842 21.9304 27.8218 21.3984 27.5842C20.8551 27.3466 20.6287 26.7242 20.8664 26.1924Z"
            fill="#FF8A93"
          />
          <Defs>
            <LinearGradient
              id="paint0_linear_2926_12805"
              x1="29.8469"
              y1="0.0332031"
              x2="29.8469"
              y2="51.7551"
              gradientUnits="userSpaceOnUse"
            >
              <Stop stopColor="#FFCF53" />
              <Stop offset="1" stopColor="#FF9900" />
            </LinearGradient>
          </Defs>
        </Svg>
      </View>
    );
  },
);

export { HexagonBee };
